export default "__VITE_ASSET__CBBYr7yy__"